import React from 'react';
import { motion } from 'framer-motion';
import Button from '../ui/Button';

const Hero = () => {
  return (
    <section className="relative w-full h-screen overflow-hidden bg-[#0a0a0a]">
      {/* 3D Spline Scene - Full Screen Background */}
      <div className="absolute inset-0 z-0 w-full h-full">
        {/* Wrapper to handle cropping/scaling for watermark removal */}
        <div className="absolute inset-0 w-full h-full transform scale-[1.2] origin-center pointer-events-none">
          <iframe 
            src='https://my.spline.design/animatedpaperboat-P6DARZbXILN4tIiXVBHmMG8x/' 
            frameBorder='0' 
            width='100%' 
            height='100%'
            className="w-full h-full"
            title="Animated Paper Boat 3D Scene"
          />
        </div>
      </div>

      {/* Cinematic Gradient Overlay - Enhances text readability and blends edges */}
      <div className="absolute inset-0 z-10 bg-gradient-to-r from-black/90 via-black/50 to-transparent pointer-events-none" />
      <div className="absolute inset-0 z-10 bg-gradient-to-t from-[#0a0a0a] via-transparent to-transparent pointer-events-none" />

      {/* Content Container */}
      <div className="relative z-20 container mx-auto px-6 h-full flex items-center">
        <motion.div 
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, ease: "easeOut", delay: 0.5 }}
          className="max-w-2xl text-left pt-20"
        >
          <span className="inline-block py-1 px-3 rounded-full bg-cyan-950/60 border border-cyan-500/30 text-cyan-400 text-[10px] font-bold tracking-[0.2em] mb-6 uppercase backdrop-blur-sm">
            SCIENCE • MATH • AI • CLASSES 5–12
          </span>
          <h1 className="text-5xl md:text-7xl font-bold text-white leading-[1.1] mb-6 tracking-tight drop-shadow-2xl">
            Set Sail into <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-400">
              Science & AI
            </span>.
          </h1>
          <p className="text-lg md:text-xl text-slate-300 mb-10 max-w-lg leading-relaxed font-light drop-shadow-lg">
            A cinematic course portal where students learn through interactive visuals, deep storytelling, and hands-on AI projects.
          </p>
          
          <div className="flex flex-wrap gap-5">
            <Button className="px-8 py-4 text-lg shadow-cyan-500/25 shadow-xl">Enter Course Portal</Button>
            <Button variant="secondary" className="px-8 py-4 text-lg backdrop-blur-md bg-black/20 border-slate-500/50 text-white hover:bg-cyan-500/20 hover:border-cyan-400">
              Explore Courses
            </Button>
          </div>
          
          <motion.div 
            initial={{ opacity: 0 }} 
            animate={{ opacity: 1 }} 
            transition={{ delay: 1.5, duration: 1 }}
            className="mt-12 flex items-center gap-4 text-xs text-slate-500 font-medium tracking-wide"
          >
            <div className="h-px w-12 bg-slate-700"></div>
            <span>Structured for school, designed for the future.</span>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;